import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import Loading from "../utilComponent/Loading";
import { request } from "../../../utils/api";
import Pagination from "../utilComponent/Pagination";

const ContactList = () => {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [pagination, setPagination] = useState({
    current_page: 1,
    per_page: 10,
    total: 0,
  });

  const fetchContacts = useCallback(async () => {
    try {
      setLoading(true);

      const params = new URLSearchParams({
        page: pagination.current_page,
        per_page: pagination.per_page,
        search: searchText || "", 
      });

      const response = await request({
        url: `contact-submissions?${params.toString()}`,
        method: "GET",
      });

      if (response?.status) {
        setContacts(response.data.items || []);
        setPagination((prev) => ({
          ...prev,
          total: response.data.pagination?.total || 0,
        }));
      }
    } catch (error) {
      toast.error("Failed to load contact submissions");
    } finally {
      setLoading(false);
    }
  }, [pagination.current_page, pagination.per_page, searchText]);

  useEffect(() => {
    fetchContacts();
  }, [fetchContacts]);

  const handleSearch = (e) => {
    setSearchText(e.target.value);
    setPagination((prev) => ({ ...prev, current_page: 1 })); 
  };

  return (
    <>
      <ToastContainer />
      <div className="container-fluid">
        <div className="page-toolbar py-3">
          <ol className="breadcrumb bg-transparent mb-0">
            <li className="breadcrumb-item">
              <Link to="/">Home</Link>
            </li>
            <li className="breadcrumb-item active">Contact</li>
            <li className="breadcrumb-item active">Contact Submissions</li>
          </ol>
        </div>

        <div className="card shadow-sm">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h6 className="m-0">Contact List</h6>
          </div>
          <div className="card-body">
             <div className="row mb-3">
      <div className="col-md-6">
        <input
          type="text"
          className="form-control"
          placeholder="Search contacts..."
          value={searchText}
          onChange={handleSearch}
        />
      </div>
    </div>
            {loading ? (
              <Loading />
            ) : contacts.length ? (
              <div className="row">
                {contacts.map((contact) => (
                  <div key={contact.id} className="col-lg-4 col-md-6 mb-4">
                    <div className="card h-100 shadow-sm">
                      <div className="card-body">
                        <h6 className="fw-bold mb-2">{contact.name || "N/A"}</h6>
                        <p className="mb-1">
                          <strong>Email:</strong> {contact.email || "-"}
                        </p>
                        <p className="mb-1">
                          <strong>Phone:</strong> {contact.phone || "-"}
                        </p>
                        <p className="mb-0">
                          <strong>Message:</strong> {contact.message || "-"}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-center py-5">No contacts found</div>
            )}

            {pagination.total > pagination.per_page && (
              <div className="d-flex justify-content-end mt-3">
                <Pagination
                  currentPage={pagination.current_page}
                  lastPage={Math.ceil(pagination.total / pagination.per_page)}
                  onPageChange={(page) =>
                    setPagination((prev) => ({
                      ...prev,
                      current_page: page,
                    }))
                  }
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactList;
